import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import { Table } from "@dev2_techwalnut/tw-react-crud-dashlite";
import { Fragment } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const SalesOrderInsightsDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const data = location.state?.data;

    const { useFetch } = useAPIQuery({
        key: `api/sales-order-batch-insights/${data?.id}/`,
        endpoint: `/api/sales-order-batch-insights/${data?.id}/`,
    });

    const { data: soData, isFetching } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: true,
        staleTime: 300000,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const updatedData = soData?.[0];

    const batchColumns = [
        {
            accessor: "batch_number",
            header: "Batch Number",
            filterable: true,
            sortable: true,
        },
        {
            accessor: "item_name",
            header: "Item Name",
            filterable: true,
            sortable: true,
        },
        {
            accessor: "total_quantity_used",
            header: "Total Quantity Used",
            sortable: true,
        },
    ];
    return (
        <Fragment>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title">
                            Sales order insights ({updatedData?.so_number})
                        </h4>
                    </div>
                    <button
                        className="btn btn-sm btn-secondary"
                        onClick={() => navigate(-1)}
                    >
                        Back
                    </button>
                </div>
            </div>
            <div className="card">
                <div className="card-inner">
                    <div className="nk-block">
                        <div className="profile-ud-list">
                            <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                    <span className="profile-ud-label">
                                        Item Name
                                    </span>
                                    <span className="profile-ud-value">
                                        {updatedData?.product_name}
                                    </span>
                                </div>
                            </div>
                            <div className="profile-ud-item">
                                <div className="profile-ud wider">
                                    <span className="profile-ud-label">
                                        Client Name
                                    </span>
                                    <span className="profile-ud-value">
                                        {updatedData?.client_name}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Table
                data={updatedData?.batch_summary?.raw_material_batches || []}
                columns={batchColumns}
                isLoading={isFetching}
                globalSearch={false}
                pagination={false}
                manualFilter={false}
                manualSorting={false}
                editRows={false}
                deleteRows={false}
                filterModal={false}
                selectRows={false}
                maxHeight={500}
            />
        </Fragment>
    );
};

export default SalesOrderInsightsDetails;
